import { EClusterFeatureContainerClassName } from '../constants/cluster';

export function getClusterFeatureClassName(items: number) {
  if (items === 1) {
    return EClusterFeatureContainerClassName.Single;
  } else if (items === 3) {
    return EClusterFeatureContainerClassName.Triple;
  }

  return EClusterFeatureContainerClassName.Double;
}
